import React, { useState } from 'react';
import { FaEdit } from "react-icons/fa";
import {
    Button,
    Form,
    Input,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    Switch,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data, categories }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/products/editProduct/${id}`, values)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'Update successfully',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                    queryClient.invalidateQueries(['/api/products/findProducts'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Update failed!',
                    });
                })
        },
    });


    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ values, id: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    // console.log(data);
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<FaEdit />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title="Edit Product"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={{ ...data, category: data.category.id }}
                >
                   <Form.Item
                        name="name"
                        label="Product Name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="Category"
                                name="category"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Category"
                                >
                                    {
                                        categories.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="Price"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={2} />
                    </Form.Item>
                    <Form.Item label="สถานะ" name="is_active" valuePropName="checked">
                        <Switch checkedChildren="Active" unCheckedChildren="Not Active" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
